window.onscroll = () => {
  if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 30) {
    document.querySelector(".nav-container").classList.add("shrink");
  } else {
    document.querySelector(".nav-container").classList.remove("shrink");
  }
};

let hamburger = document.querySelector(".navbar-toggler");
let menuIcon = document.querySelector(".main-nav__toggler-icon");
hamburger.addEventListener("click", () => {
  menuIcon.classList.toggle("main-nav__toggler-icon--close-x");
});
